import { getTerritoryNameByOrderId } from '../../../../utils/map/MapMarkersUtils';

export function createPlanPopup(data, translations, orders) {
  const {
    id,
    address,
    highPriority,
    labels,
    isPickup,
    isPudo,
    territory,
    skills,
    priority,
    group,
    pudoDuration,
    pudoAssignAt,
  } = data;

  const {
    global: { pudoLabel },
    locationPopup: { pudoDurationLabel, pudoAssignAtFirst, pudoAssignAtLast } = {},
    map: {
      typeJobDeliveryMarkerTrans,
      typeJobPickupMarkerTrans,
      territoryMarkerTrans,
      skillsMarkerTrans,
      groupMarkerTrans,
      priorityTrans,
    },
    wizard: {
      orders: { editedOrderPriorityHigh },
    },
  } = translations;

  const addressLabel = address ? `${address}<br/>` : '';
  const priorityLabel = highPriority
    ? `<div style="background-color: #FFD500; color: #000; font-weight: bold; margin-bottom: 0.5rem; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${editedOrderPriorityHigh}</div>`
    : '';
  const title = labels
    ? `<div style="color: #000; font-weight: bold; margin-bottom: 0.5rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">${priorityLabel}${addressLabel}${labels.join(
        '<br />',
      )}</div>`
    : '';

  const typeString = isPudo
    ? pudoLabel
    : isPickup
    ? typeJobPickupMarkerTrans
    : typeJobDeliveryMarkerTrans;

  const groupName =
    Array.isArray(group) && group.filter(Boolean).length > 0
      ? `<div>${groupMarkerTrans}: ${group.filter(Boolean).join(', ')}</div>`
      : '';

  const territoryFull = getTerritoryNameByOrderId(orders, id);
  const territoryName =
    territoryFull && territory?.type !== 'group'
      ? `<div>${territoryMarkerTrans}: ${territoryFull}</div>`
      : '';

  const skillsArr = skills ? `<div>${skillsMarkerTrans}: ${skills}</div>` : '';

  const priorityFull = priority ? `<div>${priorityTrans}: ${priority}</div>` : '';

  const pudoDurationStr =
    isPudo && pudoDuration != null ? `<div>${pudoDurationLabel}: ${pudoDuration}</div>` : '';
  const assignAtLabel = pudoAssignAt === 'last' ? pudoAssignAtLast : pudoAssignAtFirst;
  const pudoAssignAtStr = isPudo && pudoAssignAt != null ? `<div>${assignAtLabel}</div>` : '';

  return `${title}${typeString}${territoryName || ''}${groupName}${skillsArr}${priorityFull}${pudoDurationStr}${pudoAssignAtStr}`;
}
